import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import Store from '../../Store';
import { OnLayerMove, OnLayerSelect, OnLayerVisibility, OnLayerRename, OnLayerRemove } from '../../LayerList/_actions/LayerListActions';
import ListLayer, { Props } from '../_components/ListLayer';

const mapStateToProps = (store:Store, props:Props) => ({
	name: store.getIn(['create', 'layerList', 'layers', props.id, 'name']),
	selected: store.getIn(['create', 'layerList', 'selectedLayerId']) == props.id,
	visible: store.getIn(['create', 'layerList', 'layers', props.id, 'visible']),
	moduleIds: store.getIn(['create', 'layerList', 'layers', props.id, 'modules']),
	selectedLayerName: store.getIn(['create', 'layerList', 'layers', store.getIn(['create', 'layerList', 'selectedLayerId']), 'name']),
});

const mapDispatchToProps = (dispatch:Dispatch, props:Props) => ({
	selectLayer		: ()				=> dispatch(OnLayerSelect(props.id)),
	moveLayer		: (offset:number)	=> dispatch(OnLayerMove(props.id, offset)),
	layerVisibility	: (visible:boolean)	=> dispatch(OnLayerVisibility(props.id, visible)),
	renameLayer		: (id:string, name:string)		=> dispatch(OnLayerRename(id, name)),
	removeLayer		: (id:string)					=> dispatch(OnLayerRemove(id)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ListLayer);